// This file is auto generated by data-scripts/_helpers/runtime.ts
import commonWords from './commonWords.json';
import femaleFirstnames from './femaleFirstnames.json';
import lastnames from './lastnames.json';
import maleFirstnames from './maleFirstnames.json';
import wikipedia from './wikipedia.json';
import translations from './translations';
const dictionary = {
    commonWords,
    femaleFirstnames,
    lastnames,
    maleFirstnames,
    wikipedia,
};
export { dictionary, translations };
//# sourceMappingURL=index.js.map